import { Component, OnInit } from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {OverlayConfig, OverlayRef} from 'exc-controls';

@Component({
  selector: 'app-modal-provider-edit-audit',
  templateUrl: './modal-provider-edit-audit.component.html',
  styles: []
})
export class ModalProviderEditAuditComponent  extends ExcTranslation implements OnInit {

  auditObject;
  DatepickerConfig: any = {
    enableTime: false,
    altFormat: 'd.m.Y'
  };
  optionsMonth: any[] = [];
  optionsYear: any[] = [];
  popupData = {Year: (new Date()).getFullYear(), Month: (new Date()).getMonth() + 1  };
  auditPrio;
  auditTargetDate = new Date();

  constructor(public overlayConfig: OverlayConfig, public overlayRef: OverlayRef) {
    super();
    const _self = this;
    for (let i = 1; i <= 12; i++) {
      _self.optionsMonth.push({text: i, value: i});
    }
    for (let i = -3; i <= 3; i++) {
      _self.optionsYear.push({text: (new Date()).getFullYear() + i, value: (new Date()).getFullYear() + i});
    }
  }
  ngOnInit() {
    const _self = this;
    _self.auditObject = _self.overlayConfig.data.data;
    if (_self.auditObject.AuditPriority !== '' && _self.auditObject.AuditPriority !== null) {
      _self.auditPrio = _self.auditObject.AuditPriority;
    }
    if (_self.auditObject.AuditTargetDate !== '' && _self.auditObject.AuditTargetDate !== null) {
      _self.auditTargetDate = new Date(_self.auditTargetDate);
    }
    _self.popupData.Month = _self.auditObject.AuditMonth;
    _self.popupData.Year = _self.auditObject.AuditYear;
  }
  editAudit() {
    const _self = this;
    _self.overlayRef.close({proceed: true, AuditObject: {AuditID: _self.auditObject.AuditID,
        AuditMonth:  _self.popupData.Month,
        AuditYear:  _self.popupData.Year,
        AuditTargetDate:  _self.auditTargetDate,
        AuditPriority:  _self.auditPrio}});
  }
}
